import React, { useState, useEffect, useCallback, useRef } from "react";
import Header from "../../../Header";
// import "./customer.css";
import { RxMixerHorizontal } from "react-icons/rx";
import useFetchGet from "../hooks/useFetchGet";
import useFetchPost from "../hooks/useFetchPost";
import Dropdown from "rsuite/Dropdown";
import IconButton from "rsuite/IconButton";
import { getCookie } from "./Utility";
import { toast, Bounce } from "react-toastify";

import "rsuite/CheckPicker/styles/index.css";
import $ from "jquery";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useParams, withRouter, useLocation } from "react-router-dom";
/* Lead acccount */
import AgGridComponent from "../../AgGridComponent";
import {
  uistyles,
  predefinedRanges,
  apiRequest,
  decrypt,
  openInNewWindow,
} from "../../../utils/utils";
import FreeTrialConfirmation from "../../childcomponents/FreeTrialConfirmation";
import ListingTopFilter from "../../childcomponents/ListingTopFilter";
import CustomerMapDrawer from "../../childcomponents/CustomerMapDrawer";
import LoginToAccount from "../../childcomponents/LoginToAccount";
import MoveToDemo from "../../childcomponents/MoveToDemo";
import ExtendedFreeTrial from "../../childcomponents/ExtendedFreeTrial";
import CreateFreeTrialParent from "../../childcomponents/CreateFreeTrialParent";
import EndUserTestCredentails from "../../childcomponents/EndUserTestCredentails";
import ChangePassword from "../../childcomponents/ChangePassword";
import CancelAccount from "../../childcomponents/CancelAccount";
import RestoreAccount from "../../childcomponents/RestoreAccount";
import SubscriptionLink from "../../childcomponents/SubscriptionLink";
import DeleteAccount from "../../childcomponents/DeleteAccount";
import ManageMuviOwnerShip from "../../childcomponents/ManageMuviOwnerShip";

/* Lead acccount */

const AgGridCustomerListing = ({ history }) => {
  
  const user_uuid = getCookie("muvi_useruuid");

  const location = useLocation();
  const [customerLists, setCustomerLists] = useState([]);
  const [currentPage, setCurrentPage] = useState(
    (history.location &&
      history.location.state &&
      history.location.state.pageNumber) ||
      1
  );
  const [state, setState] = useState({
    customerMapHeader: false,
    totalCount: 0,
    aggridData: {
      app_token: process.env.REACT_APP_tattle_token,
      columnsApi: process.env.REACT_APP_get_tattle_list,
      rowsApi: `${process.env.REACT_APP_CRM}/crm/list`,
      attribute_set_key: "crm",
      search: "",
      syncFilterWithAggrid: {},
      sort: "created_date",
      order: "desc",
      actions: {},
      recallcrmapi: false,
    },
    loginToAccount: { showModal: false, data: { title: "Login To Account" } },
    moveToDemo: { showModal: false, data: { title: "Move To Demo Account" } },
    extendedFreeTrial: {
      showModal: false,
      data: { title: "Extend Free Trial" },
    },
    changePasswordModal: {
      showModal: false,
      data: { title: "Change Password" },
    },
    cancelAccountModal: {
      showModal: false,
      data: { title: "Cancel Account" },
    },
    restoreAccount: {
      showModal: false,
      data: {
        title: "Extend Trial Period",
      },
    },
    subscriptionLinkModal: {
      showModal: false,
      data: { title: "Copy Subscription Link" },
    },
    deleteAccountModal: {
      showModal: false,
      data: {
        title: "Delete Account",
      },
    },
    manageMuviOwnerShip:{
      showModal:false,
      data:{
        title:"Manage Muvi Ownership",
        longText:"Note: Assigning an account manager will mark this customer as Key Account, to Unmark it please open customer details page and Unmark it."
      }
    }
  });

  const [copied, setCopied] = useState(false);

  const { fetchData } = useFetchGet();

  const [productData, setProductData] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [packageData, setPackageData] = useState([]);
  const [accountManagerData, setAccountManagerData] = useState([]);
  const [salesManagerData, setSalesManagerData] = useState([]);
  const [tseOwnerData, setTseOwnerData] = useState([]);

  //Muvi user id to return login url
  const [muviUserId, setMuviUserId] = useState(0);
  /* customer Map Start */

  // Parse query parameters for url encrypt and dcrypt
  const searchParams = new URLSearchParams(location.search);
  const queryString = searchParams.get("debug");
  const debug = queryString == null || queryString == "false" ? false : true;

  // free trial pop up
  const [modalOpen, setModalOpen] = useState(false);
  const firstCustomerRef = useRef(null);
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [apiUrl, setApiUrl] = useState("");
  const [formData, setFormData] = useState({
    customerName: "",
    companyName: "",
    phoneNumber: "",
    emailId: "",
    password: "",
    products: [],
  });
  const [appToken, setAppToken] = useState("");

  const [testCredentialModalOpen, setTestCredentialModalOpen] = useState(false);
  const [testCredentials, setTestCredentials] = useState({
    email: "",
    password: "",
  });

  const getAccountManager = async (key) => {
    setState((state) => {
      return {
        ...state,
        isLoading: { [key]: true },
      };
    });
    const responseData = await apiRequest(
      `${process.env.REACT_APP_OWNERSHIP_URL}?email=accountmanagement@muvi.com`
    );
    if (responseData.code === 200) {
      const { data } = responseData;
      const redata = data.map((it) => ({
        label: it.name,
        value: it.user_uuid,
        ...it,
      }));

      setAccountManagerData(redata)
      
    }
  };

  const getProduct = async (key) => {
    setState((state) => {
      return {
        ...state,
        isLoading: { [key]: true },
      };
    });
    const responseData = await apiRequest(
      `${process.env.REACT_APP_CRM}/crm/product/list`
    );
    
    if (responseData) {
      const redata = responseData.map(
        ({ product_name, product_key, ...rest }, index) => ({
          label: product_name,
          value: product_key,
          data: rest,
          id: `${index + 1}`,
        })
      );

      setProductData(redata)
    }
  };
  const getSalesManager = async (key) => {
    setState((state) => {
      return {
        ...state,
        isLoading: { [key]: true },
      };
    });
    const responseData = await apiRequest(
      `${process.env.REACT_APP_OWNERSHIP_URL}?email=sales@muvi.com`
    );
    if (responseData.code === 200) {
      const { data } = responseData;
      const redata = data.map((it) => ({
        label: it.name,
        value: it.user_uuid,
        ...it,
      }));
      
     setSalesManagerData(redata)
    }
  };
  const getTseOwnerManager = async (key) => {
    setState((state) => {
      return {
        ...state,
        isLoading: { [key]: true },
      };
    });
    const responseData = await apiRequest(
      `${process.env.REACT_APP_OWNERSHIP_URL}?email=support@muvi.com`
    );
    if (responseData.code === 200) {
      const { data } = responseData;
      const redata = data.map((it) => ({
        label: it.name,
        value: it.user_uuid,
        ...it,
      }));
      
      setTseOwnerData(redata)
    }
  };

  // get product function

  const fetchTestCredentials = async () => {
    try {
      const apiUrl = `${process.env.REACT_APP_CRM}/crm/get-test-credentials`;
      const response = await fetch(apiUrl, { method: "GET" });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      

      if (data.code === 200 && data.data) {
        setTestCredentials({
          email: data.data.email || "",
          password: data.data.password || "",
        });
      } else {

        setTestCredentials({ email: "", password: "" });
      }
    } catch (error) {
      console.error("Failed to fetch test credentials:", error.message);
    }
  };

  const handleTestCredentialClick = async () => {
    await fetchTestCredentials();
    setTestCredentialModalOpen(true);
  };

  const cleanNestedObject = (obj) => {
    Object.keys(obj).forEach((key) => {
      if (typeof obj[key] === "object" && obj[key] !== null) {
        cleanNestedObject(obj[key]); // Recursively clean nested objects
      }
      if (
        obj[key] === "" ||
        (Array.isArray(obj[key]) && obj[key].length === 0)
      ) {
        delete obj[key]; // Remove empty keys
      }
    });
    return obj;
  };

  useEffect(() => {
    document.title = "Intranet | Accounts";

    // getProduct();
    //getUsers();
    getAccountManager();
    getSalesManager();
    getTseOwnerManager();
    getProduct();

    //Getting Muvi userid to return login url as a parameter
    var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
    var localdata = has_local_data
      ? decrypt(localStorage.getItem("encdata"), 0)
      : "";
    setMuviUserId(localdata);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const reactDatePopup = document.querySelector(
          ".rs-picker-popup-daterange"
        );
        if (reactDatePopup) {
          // Update the popup style when it appears
          reactDatePopup.style.left = `${window.innerWidth - 390}px`;
          reactDatePopup.style.left = "203.2px";
          observer.disconnect(); // Stop observing once the element is found
          
        }
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  /**
   * Searchbox code Start
   */
  // Define the debounce function
  const customDebounce = (func, delay) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, delay);
    };
  };

  //customer map filter

  const showCustomerMap = () => {
    setState((state) => {
      return {
        ...state,
        customerMapHeader: true,
      };
    });
  };

  const syncFilterWithAggrid = (filterdata) => {
    let newfilterdata = {};
    if (filterdata && filterdata.hasOwnProperty("search")) {
      newfilterdata = { search: filterdata.search };
    } else {
      newfilterdata = filterdata;
    }
    setState((state) => {
      return {
        ...state,
        aggridData: {
          ...state.aggridData,
          syncFilterWithAggrid: newfilterdata,
          filter:{}
        },
      };
    });
  };

  const globalSearch = (searchVal) => {

    setState(state => {
      return {
        ...state,
        aggridData:{
          ...state.aggridData,
          search:searchVal
        }
      }
    })
  }

  const reloadAgGrid = () => {
    setState((state) => {
      return {
        ...state,
        aggridData: {
          ...state.aggridData,
          recallcrmapi: !state.aggridData.recallcrmapi,
        },
      };
    });
  };

  const columnsUpdateAgGrid = () => {
    setState((state) => {
      return {
        ...state,
        aggridData: {
          ...state.aggridData,
          loadColumns: true,
        },
      };
    });
  };

  useEffect(() => {
    if (state.aggridData.loadColumns) {
      setTimeout(() => {
        setState((state) => ({
          ...state,
          aggridData: {
            ...state.aggridData,
            loadColumns: false,
          },
        }));
      }, 0);
    }
  }, [state.aggridData.loadColumns]); // Dependency on loadColumns

  const showCustomerMapClose = () => {
    setState((state) => {
      return {
        ...state,
        customerMapHeader: false,
      };
    });
  };

  const handleSelectChange = (name) => (value) => {
    

    const filters = { ...state.aggridData.filter };

    const localstorage_filter = localStorage.getItem("crm_filter");

    if (localstorage_filter) {
      // convert the string to json object

      const jsondata = JSON.parse(localstorage_filter);
      if (jsondata.crm_product) {
        filters.crm_product = { ...jsondata.crm_product };
      }
    }

    if (filters.crm_product) {
      // If crm_product exists, update it with the new name-value pair
      filters.crm_product = { ...filters.crm_product, [name]: value };
    } else {
      // If crm_product does not exist, create it with the new name-value pair
      filters.crm_product = { [name]: value };
    }
    

    localStorage.setItem("crm_filter", JSON.stringify(filters));

    setState((state) => {
      return {
        ...state,
        aggridData: {
          ...state.aggridData,
          filter: filters,
        },
      };
    });
  };
  const useQuery = () => {
    return new URLSearchParams(location.search);
  };

  useEffect(() => {
    const filters = { ...state.aggridData.filter };

    const localstorage_filter = localStorage.getItem("crm_filter");

    if (localstorage_filter) {
      // Convert the string to a JSON object
      const jsondata = JSON.parse(localstorage_filter);

      // Merge both crm_product and crm_user into filters
      filters.crm_product = jsondata.crm_product
        ? { ...jsondata.crm_product }
        : filters.crm_product;
      filters.crm_user = jsondata.crm_user
        ? { ...jsondata.crm_user }
        : filters.crm_user;
    }

    

    // Save the updated filters to localStorage
    localStorage.setItem("crm_filter", JSON.stringify(filters));

    // Update the state
    setState((state) => ({
      ...state,
      aggridData: {
        ...state.aggridData,
        filter: filters,
        syncFilterWithAggrid: filters,
      },
    }));
  }, []);

  /* customer Map End */
  useEffect(() => {
    let filters = { ...state.aggridData.filter };
    let newfilters=null;

    const checktype = useQuery().get("type");
    if(checktype) {
      
       newfilters = {crm_product:{customer_type: [checktype]}}
       filters = {...filters, ...newfilters}
       setState((state) => ({
        ...state,
        aggridData: {
          ...state.aggridData,
          filter: filters,
          syncFilterWithAggrid: filters,
        },
      }));
    }
  },[location.search])

  useEffect(() => {
    

    if (customerLists.length > 0) {
      const firstCustomer = customerLists[0];
      
      firstCustomerRef.current = firstCustomer; // Update ref
    } else {
      
      firstCustomerRef.current = null; // Reset ref
    }
  }, [customerLists]);

  const handleOkClick = async () => {
    try {
      setEmailModalOpen(false); // Close modal

      // Fetch updated customer data

      // Use the updated ref for redirection
      const firstCustomerUpdated = firstCustomerRef.current;
      if (firstCustomerUpdated) {
        
        window.location.href = `/account/${firstCustomerUpdated.customer_id}`;
      } else {
        console.warn("No customer found for redirection.");
      }
    } catch (error) {
      console.error("Error in handleOkClick:", error);
    }
  };

  const handleClickChangePasswordModal = (data) => {
    setState((state) => {
      return {
        ...state,
        changePasswordModal: {
          showModal: true,
          data: {
            ...state.changePasswordModal.data,
            ...data,
          },
        },
      };
    });
  };

  const handleConfirmToManageDemoAccount = (
    confirmText,
    product_key,
    user_uuid,
    customer_id,
    store_key,
    is_demo
  ) => {
    setState((state) => {
      return {
        ...state,
        moveToDemo: {
          ...state.moveToDemo,
          showModal: true,
          data: {
            ...state.moveToDemo.data,
            confirmText,
            product_key,
            user_uuid,
            customer_id,
            store_key,
            is_demo,
          },
        },
      };
    });
  };

  const handleClickManageMuviOwnershipModal = (data) => {
    
    setState((state) => {
      return {
        ...state,
        ownershipmodal: true,
        ownershipdata: {
          account_manager: data.account_manager,
          tse_owner: data.tse_owner,
          sales_manager: data.sales_manager,
          product_key: data.product_key,
          customer_id: data.customer_id,
        },
      };
    });
  };

  const handleClickConfirmModal = (confirmText, product_key, user_uuid, customer_id) => {
    setState((state) => {
      return {
        ...state,
        loginToAccount: {
          ...state.loginToAccount,
          showModal: true,
          data: {
            title: state.loginToAccount.data.title,
            confirmText,
            product_key,
            user_uuid,
            customer_id,
          },
        },
      };
    });
  };

  const handleConfirmManageDemoMuvi5 = async (
    confirmText,
    product_key,
    customer_id,
    is_demo
  ) => {
    setState((state) => {
      return {
        ...state,
        moveToDemo: {
          ...state.moveToDemo,
          showModal: true,
          data: {
            title: state.moveToDemo.data.title,
            confirmText,
            product_key,
            customer_id,
            is_demo,
          },
        },
      };
    });
  };

  const handleClickExtendFreeTrialModal = ({
    product_key,
    free_trial_expiry_date,
    customer,
  }) => {
    setState((state) => {
      return {
        ...state,
        extendfree: true,
        freetrial: {
          product_key,
          free_trial_expiry_date,
          ...customer,
        },
      };
    });
  };

  const mailTriggerPopup = async (appToken) => {
    try {
      setModalOpen(false);
      setAppToken(appToken);
      const emailPayload = {
        username: formData.customerName,
        email: formData.emailId,
        login_url: process.env.REACT_APP_LOGIN_URL,
        password: formData.password,
      };

      const response = await fetch(`${apiUrl}/CrmRest/FreeTrialSuccess`, {
        method: "POST",
        body: JSON.stringify(emailPayload),
      });

      const successResult = await response.json();

      if (successResult && successResult.code === 200) {
        setEmailModalOpen(true);
      } else {
        console.error("Error in mail trigger popup:", successResult);
      }
    } catch (error) {
      console.error("Error triggering mail popup:", error);
    }
  };

  const handleCopy = () => {
    const credentialsText = `Email: ${testCredentials.email}\nPassword: ${testCredentials.password}`;
    navigator.clipboard.writeText(credentialsText).then(
      () => {
        // toast.success("Both email and password copied to clipboard!", {
        //   style: { backgroundColor: "#d4edda", color: "green" }, // Custom success color
        //   autoClose: 3000, // Toast will disappear after 3 seconds
        // });

        setCopied(true)
      },
      (err) => {
        toast.error("Failed to copy text.", {
          style: { backgroundColor: "#f8d7da", color: "red" }, // Custom error color
          autoClose: 3000, // Toast will disappear after 3 seconds
        });
        console.error("Failed to copy text: ", err);
      }
    );
  };

  useEffect(() => {
    setTimeout(() => {
      setCopied(false)
    },3000)
},[copied])

  const closeLoginToModal = () => {
    setState((state) => {
      return {
        ...state,
        loginToAccount: {
          ...state.loginToAccount,
          showModal: false,
        },
      };
    });
  };

  const closeMoveToDemo = () => {
    setState((state) => {
      return {
        ...state,
        moveToDemo: {
          ...state.moveToDemo,
          showModal: false,
        },
      };
    });
  };

  const extendFreeTrialModalClose = () => {
    setState((state) => {
      return {
        ...state,
        extendedFreeTrial: {
          ...state.extendedFreeTrial,
          showModal: false,
        },
      };
    });
  };

  const extendFreeTrialHandler = (data) => {
    

    setState((state) => {
      return {
        ...state,
        extendedFreeTrial: {
          showModal: true,
          data: {
            ...state.extendedFreeTrial.data,
            ...data,
          },
        },
      };
    });
  };

  const handleClickCancelAccountModal = (data) => {
    setState((state) => {
      return {
        ...state,
        cancelAccountModal: {
          showModal: true,
          data: {
            ...data,
            is_live: false,
          },
        },
      };
    });
  };

  //login to account muvi one classic

  const handleClickConfirmModalMuviClassic = (confirmText, data) => {
    
    setState((state) => {
      return {
        ...state,
        loginToAccount: {
          ...state.loginToAccount,
          showModal: true,
          data: {
            title: state.loginToAccount.data.title,
            confirmText,
            ...data,
            isMuvi5: true,
          },
        },
      };
    });
  };

  const closePasswordModalHandler = () => {
    setState((state) => {
      return {
        ...state,
        changePasswordModal: {
          ...state.changePasswordModal,
          showModal: false,
        },
      };
    });
  };

  const closeCancelAccountHandler = () => {
    setState((state) => {
      return {
        ...state,
        cancelAccountModal: {
          ...state.cancelAccountModal,
          showModal: false,
        },
      };
    });
  };

  const handleClickRestoreModal = (data) => {
    setState((state) => {
      return {
        ...state,
        restoreAccount: {
          showModal: true,
          data: {
            title: state.restoreAccount.data.title,
            ...data,
          },
        },
      };
    });
  };
  const closeRestoreAccountHandler = () => {
    setState((state) => {
      return {
        ...state,
        restoreAccount: {
          ...state.restoreAccount,
          showModal: false,
        },
      };
    });
  };

  const handleClickSubscriptionModal = (data) => {
    setState((state) => {
      return {
        ...state,
        subscriptionLinkModal: {
          showModal: true,
          data: {
            title: state.subscriptionLinkModal.data.title,
            ...data,
          },
        },
      };
    });
  };
  const closeSubscriptionLinkModal = () => {
    setState((state) => {
      return {
        ...state,
        subscriptionLinkModal: {
          ...state.subscriptionLinkModal,
          showModal: false,
        },
      };
    });
  };

  const handleClickDeleteModal = (
    confirmText,
    product_key,
    customer_id,
    customer_user_uuid
  ) => {
    setState((state) => {
      return {
        ...state,
        deleteAccountModal: {
          showModal: true,
          data: {
            title: state.deleteAccountModal.data.title,
            confirmText,
            product_key,
            customer_id,
            customer_user_uuid,
            isLive: false,
          },
        },
      };
    });
  };

  const closeDeleteModal = () => {
    setState((state) => {
      return {
        ...state,
        deleteAccountModal: {
          ...state.deleteAccountModal,
          showModal: false,
        },
      };
    });
  };

  // total number of row count

  const getTotalCount = (count) => {
    setState((state) => {
      return {
        ...state,
        totalCount: count,
      };
    });
  };

  const handleClickExtendTrialPeriodModal = (data) => {
    setState((state) => {
      return {
        ...state,
        extendedFreeTrial: {
          showModal: true,
          data: {
            ...state.extendedFreeTrial.data,
            ...data,
          },
        },
      };
    });
  }

  const manageMuviOwnerShipHandler = (data) => {
    setState(state => {
      return {
        ...state,
        manageMuviOwnerShip:{
          ...state.manageMuviOwnerShip,
          showModal:true,
          data:{
            title: state.manageMuviOwnerShip.data.title,
            longText: state.manageMuviOwnerShip.data.longText,
            ...data,
            isLive:true
          }
        }
      }
    })
  }

  const muviOwnerShipClose = () => {
    setState(state => {
      return {
        ...state,
        manageMuviOwnerShip:{
          ...state.manageMuviOwnerShip,
          showModal:false
        }
      }
    })
  }

  return (
    <div>
      <LoginToAccount
        show={state.loginToAccount.showModal}
        data={state.loginToAccount.data}
        close={closeLoginToModal}
      />
      <MoveToDemo
        show={state.moveToDemo.showModal}
        data={state.moveToDemo.data}
        close={closeMoveToDemo}
        syncFilterWithAggrid={reloadAgGrid}
      />
      <ExtendedFreeTrial
        show={state.extendedFreeTrial.showModal}
        data={state.extendedFreeTrial.data}
        close={extendFreeTrialModalClose}
        syncFilterWithAggrid={reloadAgGrid}
      />
      <ChangePassword
        show={state.changePasswordModal.showModal}
        data={state.changePasswordModal.data}
        close={closePasswordModalHandler}
        syncFilterWithAggrid={reloadAgGrid}
      />
      <CancelAccount
        show={state.cancelAccountModal.showModal}
        data={state.cancelAccountModal.data}
        close={closeCancelAccountHandler}
      />
      <RestoreAccount
        show={state.restoreAccount.showModal}
        data={state.restoreAccount.data}
        close={closeRestoreAccountHandler}
        syncFilterWithAggrid={reloadAgGrid}
      />
      <SubscriptionLink
        show={state.subscriptionLinkModal.showModal}
        data={state.subscriptionLinkModal.data}
        close={closeSubscriptionLinkModal}
      />
      <DeleteAccount
        show={state.deleteAccountModal.showModal}
        data={state.deleteAccountModal.data}
        close={closeDeleteModal}
        syncFilterWithAggrid={reloadAgGrid}
      />
      <ManageMuviOwnerShip show={state.manageMuviOwnerShip.showModal} data={state.manageMuviOwnerShip.data} salesManager={salesManagerData} accountManager={accountManagerData} tseOwner={tseOwnerData} title={state.manageMuviOwnerShip.data.title} close={muviOwnerShipClose} syncFilterWithAggrid={reloadAgGrid}/>
      <Header brecum_name="CRM" brecum_page="Accounts" />
      <ToastContainer />
      <div className="right_col">
        <div className="customer-wrap">
          <div className="page-top" style={{ padding: "16px 0 5px" }}>
            <div className="containerfull">
              <div className="row align-items-center">
                <div className="col-md-12">
                  <div>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center title">
                      <h2>
                          Accounts{" "}
                        
                            <span class="badge-blue">{state.totalCount}</span>
                         
                        </h2>
                      </div>
                      <Dropdown
                        title="Actions"
                        className="custom-action-dropdown"
                        placement="bottomEnd"
                      >
                        <Dropdown.Item onClick={() => setModalOpen(true)}>
                          Create Trial Account
                        </Dropdown.Item>
                        <Dropdown.Item onClick={handleTestCredentialClick}>
                          End User Test Credential
                        </Dropdown.Item>
                      </Dropdown>
                    </div>
                  </div>
                </div>
                <CreateFreeTrialParent
                  show={modalOpen}
                  mailTriggerPopup={mailTriggerPopup}
                  formData={formData}
                  setFormData={setFormData}
                  apiUrl={apiUrl}
                  setApiUrl={setApiUrl}
                  productOptions={productData}
                  setModalOpen={setModalOpen}
                />

                <EndUserTestCredentails
                  testCredentials={testCredentials}
                  handleCopy={handleCopy}
                  copied={copied}
                  show={testCredentialModalOpen}
                  close={() => setTestCredentialModalOpen(false)}
                />
              </div>
              <ListingTopFilter
                productData={productData}
                aggridData={state.aggridData}
                handleSelectChange={handleSelectChange}
                showCustomerMap={showCustomerMap}
                syncFilterWithAggrid={syncFilterWithAggrid}
                accountManager={accountManagerData}
                salesManager={salesManagerData}
                tseOwner={tseOwnerData}
                globalSearch={globalSearch}
                columnsUpdateAgGrid={columnsUpdateAgGrid}
              />
            </div>
          </div>
          <div class="body-content">
            <AgGridComponent
              agData={state.aggridData}
              accountManager={accountManagerData}
              salesManager={salesManagerData}
              tseowner={tseOwnerData}
              storePermission={1}
              handleClickConfirmModal={handleClickConfirmModal}
              handleClickManageMuviOwnershipModal={
                handleClickManageMuviOwnershipModal
              }
              handleConfirmManageDemoMuvi5={handleConfirmManageDemoMuvi5}
              handleConfirmToManageDemoAccount={
                handleConfirmToManageDemoAccount
              }
              handleClickChangePasswordModal={handleClickChangePasswordModal}
              handleClickExtendFreeTrialModal={handleClickExtendFreeTrialModal}
              extendFreeTrialHandler={extendFreeTrialHandler}
              handleClickConfirmModalMuviClassic={
                handleClickConfirmModalMuviClassic
              }
              handleClickRestoreModal={handleClickRestoreModal}
              handleClickCancelAccountModal={handleClickCancelAccountModal}
              handleClickSubscriptionModal={handleClickSubscriptionModal}
              handleClickExtendTrialPeriodModal={handleClickExtendTrialPeriodModal}
              handleClickDeleteModal={handleClickDeleteModal}
              manageMuviOwnerShipHandler={manageMuviOwnerShipHandler}
              getTotalCount={getTotalCount}
              action={true}
            />
          </div>
        </div>
      </div>
      <CustomerMapDrawer
        showCustomerMapFlag={state.customerMapHeader}
        showCustomerMapClose={showCustomerMapClose}
      />
      <FreeTrialConfirmation
        formData={formData}
        show={emailModalOpen}
        close={setEmailModalOpen}
        handleOkClick={handleOkClick}
      />
    </div>
  );
};

export default withRouter(AgGridCustomerListing);



// WEBPACK FOOTER //
// ./src/components/crm/customer/AgGridCustomerListing.js